var _path, _path2, _rect, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEid = function SvgEid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37 20.9514V11.0833C37 8.8375 35.2237 7 33.0526 7H15.9474C13.7763 7 12 8.8375 12 11.0833V51.9167C12 54.1625 13.7763 56 15.9474 56H33.0526C35.2237 56 37 54.1625 37 51.9167V44.0903",
    stroke: "black",
    strokeWidth: 1.27696,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23 10H26",
    stroke: "black",
    strokeWidth: 1.27696,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 21.054,
    y: 21.5747,
    width: 31.946,
    height: 18.3519,
    rx: 2.55392,
    fill: "#2F6D7B",
    stroke: "black",
    strokeWidth: 1.27696
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.406 29.3232L41.581 27.0122L43.892 29.3232L46.203 27.0122L48.514 29.3232",
    stroke: "white",
    strokeWidth: 1.27696,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0272 33.0771L33.4455 35.8482H25.1322L25.5505 33.0771C25.655 32.2929 26.2825 31.77 27.0667 31.77H29.2627H31.4586C32.2429 31.77 32.9226 32.3451 33.0272 33.0771Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5696 27.5351C30.9879 27.901 31.2493 28.4239 31.2493 28.999C31.2493 29.1036 31.2493 29.1559 31.2493 29.2605C31.1447 30.2016 30.3082 30.9336 29.3148 30.9336C28.2168 30.9336 27.3802 30.0447 27.3802 28.999C27.3802 28.8945 27.3802 28.7899 27.3802 28.6853C27.5371 27.7442 28.3214 27.0122 29.3148 27.0122C29.3671 27.0122 29.4716 27.0122 29.5239 27.0122C29.8899 27.1168 30.2559 27.2736 30.5696 27.5351Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.054 32.4502V41.791C21.054 43.2015 22.1974 44.345 23.6079 44.345H50.446C51.8565 44.345 52.9999 43.2015 52.9999 41.791V32.4502",
    stroke: "black",
    strokeWidth: 1.27696
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16 23V18.8779C16 17.8244 16.8244 17 17.8779 17H22",
    stroke: "black",
    strokeWidth: 1.27696,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22 49L17.8779 49C16.8244 49 16 48.1756 16 47.1221L16 43",
    stroke: "black",
    strokeWidth: 1.27696,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgEid;